import { StateCreator } from 'zustand';
import { GameState } from '../gameStore';

export interface PlayerSlice {
  playerColor: 'white' | 'black' | 'random';
  boardOrientation: 'white' | 'black';
  playerName: string;
  
  setPlayerColor: (color: 'white' | 'black' | 'random') => void;
  setPlayerName: (name: string) => void;
}

export const createPlayerSlice: StateCreator<
  GameState,
  [],
  [],
  PlayerSlice
> = (set, get) => ({
  playerColor: 'white',
  boardOrientation: 'white',
  playerName: 'Player 1',
  
  setPlayerColor: (color) => {
    let newOrientation: 'white' | 'black' = color === 'white' ? 'white' : 'black';
    set({ playerColor: color });
    if (color !== 'random') {
      set({
        boardOrientation: newOrientation
      });
    }
  },
  
  setPlayerName: (name) => set({ playerName: name }),
});